import { getEnv } from '@/lib/env';

declare global {
  interface Window {
    CKEDITOR_BASEPATH: string;
    CKFINDER_BASEPATH: string;
  }
}

function getConfig() {
  const env = getEnv();
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const config = require(`./config.${env}`).default;
  return {
    ...config,
    /** Local CKEditor script URL (patched build). Pass as editorUrl to ckeditor4-react to avoid CDN. */
    ckEditorScriptUrl:
      typeof window !== 'undefined' && window.CKEDITOR_BASEPATH
        ? `${window.CKEDITOR_BASEPATH}ckeditor.js`
        : '',
  };
}

export default getConfig();
